module.exports = __webpack_public_path__ + "static/img/5.75b6544d.png";